import './polyfill';
import React from 'react';
import './App';
import * as AppContext from '/src/AppContext';
import Layout from './Components/Layout';

export function PageContainer(props) {
  return (
    <Layout {...props} seo={props.pageContext.seo || {}}>
      {props.children}
    </Layout>
  );
}

export function AppRoot(props) {
  return <AppContext.Provider {...props}>{props.children}</AppContext.Provider>;
}
